import { Component } from 'angular-ts-decorators';
import type { LocalStorage } from '@shared/app/scripts/services/local-storage';

/**
 * Component that displays the main menu.
 *
 * @example
 * <sw-main-menu></sw-main-menu>
 */
@Component({
  selector: 'swMainMenu',
  transclude: true,
  template: require('./sw-main-menu.html').default,
})
export class SwMainMenuComponent {
  constructor(
    private $document: ng.IDocumentService,
    private localStorage: LocalStorage,
  ) {
    'ngInject';
  }

  // TODO figure out a way of doing that without messing with event
  toggle(event) {
    if (
      event.currentTarget?.parentElement?.classList[0] !== 'indent' ||
      JSON.parse(this.localStorage.getItem('sidebarIsCollapsed'))
    ) {
      const currentOpened = angular.element(
        this.$document[0].querySelectorAll('.menu-link__header.open'),
      );

      event.currentTarget.parentElement.classList.toggle('open');
      currentOpened.removeClass('open');
    }
  }
}
